import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
  Button,
  TextField,
  MuiThemeProvider,
  createTheme,
	FormControlLabel,
	Checkbox
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { deleteUser, getUserById, postUser, updateUser } from '../../../../api/user'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { Col, Row } from 'react-bootstrap'

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyAdmin() {
  return {
    fullName: '',
    email: '',
    // role: 'admin',
    isAdmin: true,
    isTherapist: false,
    acronym: '',
    password: '',
    repeatPassword: '',
    active: true
  }
}

function isValidAcronym(acronym) {
  return /^[A-Z]{3}$/.test((acronym || '').trim().toUpperCase())
}

export default function EditAdminsPage() {
  const [admin, setAdmin] = useState(getEmptyAdmin())
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [newPassword, setNewPassword] = useState({ password: null, repeatPassword: null })
	const [changePassword, setChangePassword] = useState(false)
  const adminId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!adminId) {
      disableLoadingData()
      return
    }
    getUserById(adminId).then(res => {
      if (res.status === 200) {
        const user = res.data
        delete user.password
        setAdmin(user)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'No se ha podido encontrar el administrador.' })
      history.push('/admins')
    })
  }, [adminId, disableLoadingData, history])

  function saveAdmin() {
		let saveAdmin = { ...admin }

		if (saveAdmin.isTherapist) {
		  const normalizedAcronym = (saveAdmin.acronym || '').trim().toUpperCase()
		  if (!isValidAcronym(normalizedAcronym)) {
        alertError({ error: null, customMessage: 'El acrónimo es obligatorio y debe tener exactamente 3 letras.' })
        return
		  }
		  saveAdmin.acronym = normalizedAcronym
		} else {
		  delete saveAdmin.acronym
		}

		if (!adminId || changePassword) {
		  if (!newPassword.password || !newPassword.repeatPassword) {
        alertError({ error: null, customMessage: 'Porfavor introduce una contraseña.' })
        return
		  }
		  if (newPassword.password !== newPassword.repeatPassword) {
        alertError({ error: null, customMessage: 'Las contraseñas no coinciden.' })
        return
		  }
		  saveAdmin = {...saveAdmin, password: newPassword.password }
		}
    if (!adminId) {
      postUser(saveAdmin).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: 'Guardado!', customMessage: 'Administrador creado correctamente.' })
          history.push('/admins')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se ha podido guardar el administrador.' })
      })
    } else {
      updateUser(adminId, saveAdmin).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Guardado!', customMessage: 'Cambios guardados correctamente.' })
          history.push('/admins')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'No se han podido guardar los cambios.' })
      })
    }
  }

  const handleChange = (element) => (event) => {
    setAdmin({ ...admin, [element]: event.target.value })
  }

  const handleAcronymChange = (event) => {
    const value = event.target.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3)
    setAdmin({ ...admin, acronym: value })
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Editar administrador'>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <TextField
                id={`fullName`}
                label="Nombre"
                value={admin.fullName}
                onChange={handleChange('fullName')}
                InputLabelProps={{
                  shrink: true
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </Col>
            <Col>
              <TextField
                id={`surname`}
                label="Apellidos"
                value={admin.surname}
                onChange={handleChange('surname')}
                InputLabelProps={{
                  shrink: true
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField
                id={`email`}
                label="Correo electrónico"
                value={admin.email}
                onChange={handleChange('email')}
                InputLabelProps={{
                  shrink: true
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </Col>
            <Col>
              <TextField
                id={`phone`}
                label="Teléfono"
                value={admin.phone}
                onChange={handleChange('phone')}
                InputLabelProps={{
                  shrink: true
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </Col>
          </Row>
						{(!adminId || changePassword) ? <>
							<TextField
								id={`password`}
								label="Contraseña"
								value={newPassword.password}
								onChange={(event) => {
									if (event.target.value !== ' ') setNewPassword({ ...newPassword, password: event.target.value })
								}}
								InputLabelProps={{
									shrink: true
								}}
								type="password"
								margin="normal"
								variant="outlined"
								required
							/>
							<TextField
								id={`repeatPassword`}
								label="Repite la contraseña"
								value={newPassword.repeatPassword}
								onChange={(event) => {
									if (event.target.value !== ' ') setNewPassword({ ...newPassword, repeatPassword: event.target.value })
								}}
								InputLabelProps={{
									shrink: true
								}}
								type="password"
								margin="normal"
								variant="outlined"
								required
							/>
							{adminId && <>
                <br />
                <br />
								<Button
									onClick={() => {
										setChangePassword(false)
										setNewPassword({ password: null, repeatPassword: null })
									}}
									variant="outlined"
									style={{ marginRight: '20px' }}
								>
									Cancelar cambio de contraseña
								</Button>
                <br />
							</>}
							</> : <>
              <br />
              <Row>
                <Col>
                  <Button
                    onClick={() => setChangePassword(true)}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: '20px' }}
                  >
                    Cambiar contraseña
                  </Button>
                </Col>
              </Row>
              <Row>
                  <Col>
                  </Col>
              </Row>
						</>}
						<br/>
						<FormControlLabel
							control={<Checkbox checked={admin.active} onChange={() => setAdmin({ ...admin, active: !admin.active })} name="checkActive" />}
							label="Activo"
						/>
						<FormControlLabel
							control={<Checkbox checked={admin.isTherapist} onChange={() => setAdmin({ ...admin, isTherapist: !admin.isTherapist })} name="checkIsTherapist" />}
							label="Es terapeuta"
						/>
						{admin.isTherapist && (
              <Row>
                <Col sm={4}>
                  <TextField
                    id="acronym"
                    label="Acrónimo"
                    value={admin.acronym || ''}
                    onChange={handleAcronymChange}
                    InputLabelProps={{ shrink: true }}
                    margin="normal"
                    variant="outlined"
                    required
                    inputProps={{ maxLength: 3, style: { textTransform: 'uppercase' } }}
                    helperText="3 letras, ej. BAR, TON"
                  />
                </Col>
              </Row>
            )}
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/admins')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Atrás
      </Button>
      <Button
        onClick={() => saveAdmin()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Guardar administrador
      </Button>
      {adminId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Eliminar administrador
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'Seguro que quieres eliminar el administrador?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteUser(adminId).then(res => {
              if (res.status === 204 || res.status === 200) {
                alertSuccess({ title: 'Eliminado!', customMessage: 'Administrador eliminado correctamente!' })
                history.push('/admins')
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'No se ha podido eliminar.' })
            })
          }}
        />
      </>}
    </>
  );
}
